import { render, staticRenderFns } from "./ArchivedCombos.vue?vue&type=template&id=4e666862&"
import script from "./ArchivedCombos.vue?vue&type=script&lang=js&"
export * from "./ArchivedCombos.vue?vue&type=script&lang=js&"
import style0 from "./ArchivedCombos.vue?vue&type=style&index=0&id=4e666862&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports